document.addEventListener("DOMContentLoaded", function () {
  // Elements
  const laserEngravingOption = document.getElementById("laserEngravingOption");
  const laserEngravingCheckbox = document.getElementById(
    "laserEngravingCheckbox"
  );
  const engravingModal = document.getElementById("engravingModal");
  const closeButton = document.querySelector(".close-engraving");
  const closeButtonModal = document.querySelector(".engraving-modal-overlay");
  const engravingText = document.getElementById("engravingText");
  const engravingTextTwo = document.getElementById("engravingText2");
  const engravingPreview = document.getElementById("engravingPreview");
  const engravingPreviewTwo = document.getElementById("engravingPreview2");
  const termsAccepted = document.getElementById("termsAccepted");
  const saveButton = document.getElementById("saveEngraving");
  const cancelButton = document.getElementById("cancelEngraving");
  const selectedText = document.getElementById("selectedEngravingText");
  const editButton = document.getElementById("editEngraving");
  const engravingProperty = document.getElementById("engravingProperty");
  const gravureLineOne = document.getElementById("gravureLineOne");
  const gravureLineTwo = document.getElementById("gravureLineTwo");
  const addOnPrice = laserEngravingOption.querySelector(".add-on-price");

  // State
  let isEngraved = false;
  let currentEngravingText = "";
  let currentEngravingTextTwo = "";

  // Open modal when clicking on the engraving option
  laserEngravingOption.addEventListener("click", function () {
    if (!isEngraved) {
      openEngravingModal();
    }
  });

  // Edit button to modify existing engraving
  editButton.addEventListener("click", function (e) {
    e.stopPropagation();
    openEngravingModal();
  });

  // Close modal when clicking on close button
  closeButton.addEventListener("click", closeEngravingModal);

  closeButtonModal.addEventListener("click", closeEngravingModal);

  // Close modal when the Esc key is pressed
  document.addEventListener("keydown", function (event) {
    if (
      event.key === "Escape" &&
      engravingModal.classList.contains("visible")
    ) {
      closeEngravingModal();
    }
  });

  // Update preview as user types
  engravingText.addEventListener("input", function () {
    currentEngravingText = this.value;
    updateEngravingPreview();
    validateForm();
  });

  // Update preview as user types
  engravingTextTwo.addEventListener("input", function () {
    currentEngravingTextTwo = this.value;
    updateEngravingPreview();
  });

  // Terms checkbox validation
  termsAccepted.addEventListener("change", validateForm);

  // Save engraving
  saveButton.addEventListener("click", function () {
    if (currentEngravingText.trim() !== "") {
      isEngraved = true;
      selectedText.textContent =
        `${currentEngravingText} ${currentEngravingTextTwo}`.trim();
      selectedText.style.display = "block";
      editButton.style.display = "inline-block";
      engravingProperty.value =
        `${currentEngravingText} ${currentEngravingTextTwo}`.trim();
      gravureLineOne.value = currentEngravingText;
      gravureLineTwo.value = currentEngravingTextTwo;
      // Hide the price indicator when engraved, but check if it exists first
      if (addOnPrice) {
        addOnPrice.style.display = "none";
      }

      // Update the option display to show the engraving is selected
      laserEngravingOption.classList.add("selected");
      laserEngravingCheckbox.checked = true;

      closeEngravingModal();
    }
  });

  // Cancel/remove engraving
  cancelButton.addEventListener("click", function () {
    removeEngraving();
    closeEngravingModal();
  });

  // Functions
  function openEngravingModal() {
    // Add body class to prevent scrolling
    document.body.classList.add("modal-open");
    engravingModal.classList.remove("invisible");
    engravingModal.classList.add("visible");
    if (isEngraved) {
      engravingText.value = currentEngravingText;
      engravingTextTwo.value = currentEngravingTextTwo;
      updateEngravingPreview();
    } else {
      engravingText.value = "";
      engravingTextTwo.value = "";
      engravingPreview.textContent = "";
      engravingPreviewTwo.textContent = "";
    }
    validateForm();
  }

  function closeEngravingModal() {
    document.body.classList.remove("modal-open");
    engravingModal.classList.remove("visible");
    setTimeout(() => {
      engravingModal.classList.add("invisible");
    }, 300);

    if (currentEngravingText.trim() == "" || !termsAccepted.checked) {
      laserEngravingCheckbox.checked = false;
    }
  }

  function updateEngravingPreview() {
    engravingPreview.textContent = currentEngravingText;
    engravingPreviewTwo.textContent = currentEngravingTextTwo;
  }

  function validateForm() {
    const isTextValid = engravingText.value.trim() !== "";
    const isTermsChecked = termsAccepted.checked;

    saveButton.disabled = !(isTextValid && isTermsChecked);
  }

  function removeEngraving() {
    isEngraved = false;
    currentEngravingText = "";
    currentEngravingTextTwo = "";
    selectedText.textContent = "";
    selectedText.style.display = "none";
    editButton.style.display = "none";
    engravingProperty.value = "";
    gravureLineOne.value = "";
    gravureLineTwo.value = "";
    
    laserEngravingOption.classList.remove("selected");
    laserEngravingCheckbox.checked = false;
    // Check if addOnPrice exists before modifying it
    if (addOnPrice) {
      addOnPrice.style.display = "inline-block";
    }
  }

  laserEngravingCheckbox.addEventListener("change", function () {
    if (!this.checked) {
      removeEngraving();
    }
  });
});
